/* istanbul ignore file */
import { ARTIFACT_ID } from 'domain/shared/artifact';
import { WysiwygInputPasteArtifactDecorator } from 'domain/shared/artifact/input';
import { WysiwygInput } from 'framework/form';

type CrmNoteWysiwygInputProps = {
  artifactsSource: string;
  source: string;
};

const CrmNoteWysiwygInput = ({ artifactsSource, ...props }: CrmNoteWysiwygInputProps) => {
  return (
    <WysiwygInputPasteArtifactDecorator artifactsSource={artifactsSource} artifactTypeId={ARTIFACT_ID.CRM_ATTACHMENT}>
      <WysiwygInput {...props} />
    </WysiwygInputPasteArtifactDecorator>
  );
};

export default CrmNoteWysiwygInput;
